import React, { Component } from 'react';
import GoogleAnalytics from 'react-ga';

// const GA_TRACKING_ID = 'UA-18122665-14';    // DEVELOPMENT
const GA_TRACKING_ID = 'G-JS6M2HGG2S'; // PRODUCTION

GoogleAnalytics.initialize(GA_TRACKING_ID, {
  // debug: true,  // shows logs in browser console
  titleCase: false,
  // gaOptions: {
  //   userId: 123
  // }
});


const withTracker = ({ component, options = {}, componentProps }) => {
  const WrappedComponent = component;
  const trackPage = page => {
    GoogleAnalytics.set({
      page,
      ...options,
    });
    GoogleAnalytics.pageview(page);
  };

  const HOC = class extends Component {
    componentDidMount() {
      //const page = this.props.location.pathname;
      const page = this.props.location.search?this.props.location.pathname+this.props.location.search:this.props.location.pathname;		
      trackPage(page);
    }

    componentWillReceiveProps(nextProps) {
      const currentPage = this.props.location.pathname;
      const nextPage = nextProps.location.pathname;

      if (currentPage !== nextPage) {
        trackPage(nextPage);
      }
    }

    render() {
      return <WrappedComponent {...this.props} {...componentProps} />;
    }
  };

  return HOC;
};

export default withTracker;


// WEBPACK FOOTER //
// ./src/routes/with-tracker/index.js